export enum Report2SpecialSourceType {
  NONE = 'NONE',
  X_INVOICE = 'X_INVOICE',
  ALL_IN_ONE_REPORT_BZ_OBJECT = 'ALL_IN_ONE_REPORT_BZ_OBJECT',
}
